import {useEffect, useMemo, useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {setPrismProgram, selectPrismProgram} from '../slices/customDashboardViewSlice'

export const useCustomDashboardViewProvider = () => {
  const dispatch = useDispatch()
  const prismProgram = useSelector(selectPrismProgram)

  useEffect(() => {
    const currentUrl = globalThis.location.href
    if (currentUrl?.includes('peopleprism')) {
      dispatch(setPrismProgram('PeoplePrism'))
      document.title = 'PeoplePrism'
    } else {
      dispatch(setPrismProgram('HealthPrism'))
      document.title = 'HealthPrism'
    }
  }, [dispatch])

  const setPrismProgramCallback = useCallback(
    (program) => {
      dispatch(setPrismProgram(program))
    },
    [dispatch]
  )

  const values = useMemo(
    () => ({
      prismProgram,
      setPrismProgram: setPrismProgramCallback
    }),
    [prismProgram, setPrismProgramCallback]
  )

  return values
}
